var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4382_11771)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36035 0.734375C7.84195 0.700707 9.27955 1.23909 10.374 2.23828C11.4684 3.23747 12.1353 4.62019 12.2363 6.09863C12.3321 7.50096 11.9104 8.88634 11.0576 9.99707L14.8535 13.793L13.793 14.8535L9.99707 11.0576C8.88634 11.9104 7.50096 12.3321 6.09863 12.2363C4.62019 12.1353 3.23747 11.4684 2.23828 10.374C1.23909 9.27955 0.700707 7.84195 0.734375 6.36035C0.76807 4.87872 1.371 3.46689 2.41895 2.41895C3.46689 1.371 4.87872 0.76807 6.36035 0.734375ZM7.3291 2.33203C6.50485 2.1681 5.65047 2.25172 4.87402 2.57324C4.09758 2.89486 3.43378 3.43995 2.9668 4.13867C2.49982 4.83755 2.25002 5.65947 2.25 6.5L2.25586 6.71094C2.30914 7.76084 2.74926 8.75701 3.49609 9.50391C4.29281 10.3006 5.37328 10.7486 6.5 10.75C7.34052 10.75 8.16245 10.5011 8.86133 10.0342C9.56014 9.56725 10.1051 8.9034 10.4268 8.12695C10.7484 7.35037 10.832 6.49532 10.668 5.6709C10.504 4.84655 10.0992 4.08945 9.50488 3.49512C8.91053 2.90081 8.15347 2.49601 7.3291 2.33203Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4382_11771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch2);
export default __webpack_public_path__ + "static/media/icon_search2.404754e21f578c18e4ef6466e03aea0b.svg";
export { ForwardRef as ReactComponent };